import { Box, useMediaQuery, useTheme, Drawer } from "@mui/material";
import Sidebar from "Components/Dashboard/Sidebar";
import Topbar from "Components/Dashboard/Topbar";
import { SIDEBAR_CONFIG } from "Constants/SidebarConfig";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../Redux/User/Action";
import { UserInitialStateType } from "DataTypes/Redux";
import ImgPath from "Constants/Imgs";

const MainLayout = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false); // Default: expanded
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const toggleSidebar = () => {
    setMobileOpen(!mobileOpen);
  };

  // Inject Zoho script only once when component mounts
  // useEffect(() => {
  //   // Define the global Zoho object before script loads
  //   (window as any).$zoho = (window as any).$zoho || {};
  //   (window as any).$zoho.salesiq = (window as any).$zoho.salesiq || {
  //     ready: function () {},
  //   };

  //   // Create script tag
  //   const script = document.createElement("script");
  //   script.id = "zsiqscript";
  //   script.src =
  //     "https://salesiq.zohopublic.in/widget?wc=siqd7707a9039bd6effac697257b5da4841f1a7b648d2deaf53c922eb053d319179";
  //   script.defer = true;
  //   // Append it just before the closing </body>
  //   document.body.appendChild(script);
  //   const interval = setInterval(() => {
  //     const zohoWidget = document.getElementById("zsiq_float"); // Zoho bubble id
  //     if (zohoWidget) {
  //       zohoWidget.style.bottom = "70px"; // move higher (default is ~20-30px)
  //       zohoWidget.style.right = "10px";  // keep aligned with your WhatsApp icon
  //       clearInterval(interval);
  //     }
  //   }, 500); // check every 0.5s until widget exists
  
  //   return () => clearInterval(interval);
  // }, []);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const handleLogout = () => {
    localStorage.clear();
    dispatch(clearUser() as any);
    navigate("/");
  };

  // Dynamic drawer width based on collapse state
  const drawerWidth = isCollapsed
    ? SIDEBAR_CONFIG.collapsedWidth
    : SIDEBAR_CONFIG.expandedWidth;

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        bgcolor: "#fff",
        overflow: "hidden",
        margin: 0,
        padding: 0,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      {/* Sidebar for md+ screen */}
      {isMdUp ? (
        <Box
          component="nav"
          sx={{
            width: drawerWidth,
            height: "100vh",
            flexShrink: 0,
            transition: `width ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
          }}
          className="sidebar-box"
        >
          <Sidebar
            drawerWidth={drawerWidth}
            isCollapsed={isCollapsed}
            onToggleCollapse={toggleCollapse}
            handleLogout={handleLogout}
          />
        </Box>
      ) : (
        <Drawer
          open={mobileOpen}
          onClose={toggleSidebar}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: SIDEBAR_CONFIG.expandedWidth, // Always use expanded width for mobile
              bgcolor: "#a24857",
              color: "#fff",
            },
          }}
        >
          <Sidebar
            drawerWidth={SIDEBAR_CONFIG.expandedWidth}
            isCollapsed={false} // Never collapsed on mobile
            onToggleCollapse={() => {}} // No-op for mobile
            onClose={toggleSidebar}
          />
        </Drawer>
      )}

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
        className="main-layout"
      >
        <Topbar onMenuClick={toggleSidebar} />
        <Box
          component="main"
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height:
              myInfo?.userType === "USER"
                ? "calc(100vh - 140px)"
                : "calc(100vh - 80px)", // Dynamic height based on user type
            padding: 0, // Remove any default padding
            margin: 0, // Remove any default margin
          }}
        >
          <Box sx={{ flex: 1, overflow: "hidden", mt: 1 }}>
            <Outlet />
          </Box>
          <Box
            component="a"
            href="https://wa.me/919326024128"
            target="_blank"
            rel="noopener"
            className="whatsapp-float"
            sx={{
              position: "fixed",
              bottom: 30,
              left: 10,
              width: { xs: 50, sm: 60, md: 60, lg: 60, xl: 60 },
              height: { xs: 50, sm: 60, md: 60, lg: 60, xl: 60 },
              zIndex: 1000,
              cursor: "pointer",
              background:
                "linear-gradient(90deg, rgb(18, 198, 101) 0.85%, rgb(0, 148, 70) 100%)",
              borderRadius: "50%",
              p: { xs: 1, sm: 1.5 },
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
              transition: "transform 0.2s ease-in-out",
            }}
          >
            <Box
              component="img"
              src={ImgPath.WhatsAppIcon}
              alt="Chat on WhatsApp"
              sx={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
